export default __webpack_public_path__ + "static/media/safariAdminCustomers.fdaaea42.PNG";